<script lang="ts" setup>
import { Heading, type HeadingProps } from "~/components/clarity-ui/Heading";
import type { mgnlHeadline } from "~/types/magnolia";
import { contentToTailwindClasses } from "~/utils/helper/tailwind";

export interface SingleHeadlineComponentProps {
  alignment?: string;
  fontSize?: number;
  headline?: mgnlHeadline;
  sameFontSize?: boolean;
  subline?: string;
  textColor?: string;
  highlight?: string;
  fontFamily?: string;
}

defineProps<SingleHeadlineComponentProps>();

// todo: these mappings are necessary to map the Magnolia datafeed to component's interface
const headingColorMapping = { white: "light", black: "dark", blue: "blue" } as Pick<
  HeadingProps,
  "color"
>;
const headingSizeMapping = ["xxlarge", "xlarge", "large", "medium", "xxxlarge"] as Pick<
  HeadingProps,
  "size"
>;
const headingWeightMapping = { regular: "normal", medium: "bold" } as Pick<HeadingProps, "weight">;
</script>

<template>
  <div
    :class="[
      contentToTailwindClasses({
        flexItems: alignment,
        textAlign: alignment,
      }),
      {
        'gap-2 xl:gap-4': !sameFontSize,
      },
    ]"
    class="flex flex-col"
  >
    <!-- TODO fontFamily shall probably move to Heading Options-->
    <Heading
      v-if="headline.text"
      :color="headingColorMapping[headline?.textColor]"
      :size="headingSizeMapping[fontSize]"
      :tag="headline?.tag ?? 'h2'"
      :weight="headingWeightMapping[headline?.fontWeight]"
      :class="contentToTailwindClasses({ highlight, fontFamily })"
      >{{ headline.text }}</Heading
    >
    <Heading
      v-if="subline"
      :size="
        sameFontSize ? headingSizeMapping[fontSize] : headingSizeMapping[Math.min(3, fontSize + 2)]
      "
      tag="div"
      weight="normal"
    >
      {{ subline }}
    </Heading>
  </div>
</template>
